// SearchBar.jsx
import React, { useState } from 'react';

export default function SearchBar({ onSearch }) {
  const [query, setQuery] = useState('');

  const handleSearch = () => { if (onSearch) onSearch(query); };
  const handleKeyDown = (e) => { if (e.key === 'Enter') handleSearch(); };

  return (
    <div className="flex items-center gap-3 mb-4">
      {/* Search field */}
      <div className="flex flex-1 items-center gap-2.5 bg-white border border-gray-200 rounded-xl px-3.5 py-2.5 shadow-sm">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="shrink-0">
          <circle cx="11" cy="11" r="8" stroke="#9ca3af" strokeWidth="2" />
          <path d="M21 21l-4.35-4.35" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" />
        </svg>
        <input
          type="text"
          placeholder="Search here"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={handleKeyDown}
          className="flex-1 border-none outline-none text-sm text-gray-700 bg-transparent placeholder-gray-400"
        />
      </div>

      {/* Search button */}
      <button
        onClick={handleSearch}
        className="px-5 py-2.5 bg-white border border-gray-300 rounded-xl text-sm font-semibold text-gray-700 cursor-pointer shadow-sm hover:border-green-600 hover:text-green-600 transition-colors whitespace-nowrap"
      >
        Search
      </button>

   
    </div>
  );
}